/**
 * Rewards 页面 UI 层类型定义 - 匹配 mock 数据结构
 */

// Habit typeings
export type HabitType =
  | 'timeManagement'    // 时间管理
  | 'studyFocus'        // 学习专注
  | 'lifeCare'          // 生活自理
  | 'sportsHealth'      // 运动健康
  | 'responsibility'    // 责任担当
  | 'etiquette'         // 言行礼仪

// Rule base interface
export interface BaseRule {
  id: string;
  name: string;
  type: 'reward' | 'punishment';
  points: number;
  habits: HabitType[];
  description: string;
  triggerCount: number;
  yearTriggerCount: number;
  totalPoints: number;
  enabled: boolean;
  dailyCheckIn: boolean;
}

// Reward rule
export interface RewardRule extends BaseRule {
  type: 'reward';
  repeatPenalty: false;
  penaltyMultiplier: 1.0;
  timerEnabled?: boolean;
  deadlineHour?: number;
  deadlineMinute?: number;
  earlyBonus?: number;
  earlyBonusInterval?: number;
}

// Punishment rule
export interface PunishRule extends BaseRule {
  type: 'punishment';
  repeatPenalty: boolean;
  penaltyMultiplier: number;
}

export type Rule = RewardRule | PunishRule;

// Points Store Item
export interface PointsStoreItem {
  id: string;
  name: string;
  cost: number;
  category: string;
  icon: string;
  iconBg: string;
  description: string;
  redeemCount: number;
  enabled: boolean;
  hasCountdown?: boolean;
  countdownMinutes?: number;
}

// Habit labels and colors for UI
export const HABIT_LABELS: Record<HabitType, string> = {
  timeManagement: '时间管理',
  studyFocus: '学习专注',
  lifeCare: '生活自理',
  sportsHealth: '运动健康',
  responsibility: '责任担当',
  etiquette: '言行礼仪'
};

export const HABIT_COLORS: Record<HabitType, string> = {
  timeManagement: 'bg-blue-500',
  studyFocus: 'bg-violet-500',
  lifeCare: 'bg-emerald-500',
  sportsHealth: 'bg-amber-500',
  responsibility: 'bg-rose-500',
  etiquette: 'bg-teal-500'
};

// Category labels for store
export const CATEGORY_LABELS: Record<string, string> = {
  all: '全部',
  companionship: '亲子陪伴',
  activity: '户外活动',
  toy: '玩具礼物',
  food: '美食奖励',
  privilege: '特权解锁',
  book: '知识成长'
};

// Available icons for store items
export const AVAILABLE_ICONS = [
  { icon: 'ri-movie-fill', label: '电影' },
  { icon: 'ri-gamepad-fill', label: '游戏' },
  { icon: 'ri-gift-2-fill', label: '礼物' },
  { icon: 'ri-restaurant-fill', label: '餐厅' },
  { icon: 'ri-cake-3-fill', label: '蛋糕' },
  { icon: 'ri-book-3-fill', label: '书籍' },
  { icon: 'ri-run-fill', label: '运动' },
  { icon: 'ri-star-fill', label: '星星' },
  { icon: 'ri-heart-fill', label: '爱心' },
  { icon: 'ri-music-fill', label: '音乐' },
  { icon: 'ri-map-pin-2-fill', label: '地图' },
  { icon: 'ri-trophy-fill', label: '奖杯' },
  { icon: 'ri-sword-fill', label: '游戏' },
  { icon: 'ri-umbrella-fill', label: '出游' },
  { icon: 'ri-flight-takeoff-fill', label: '旅行' },
  { icon: 'ri-restaurant-2-fill', label: '厨房' },
];

// Color presets for store item backgrounds
export const COLOR_PRESETS = [
  '#ef4444', '#f97316', '#f59e0b', '#10b981', '#3b82f6',
  '#8b5cf6', '#ec4899', '#0d9488', '#1a56db', '#dc2626'
];
